<div class="usa-modal usa-modal--lg" id="example-modal-2" aria-labelledby="modal-2-heading" aria-describedby="modal-2-description">
  <div class="usa-modal__content">
    <div class="usa-modal__main">
      <h2 class="usa-modal__heading" id="modal-2-heading">
        Message List
      </h2>
      <div ng-controller="ModalCtrl">
        <div class="usa-prose">
          <form [formGroup]='hhgMessageForm'>
            <div id="modal-2-description">
              Accessorial Service: <b>{{title}}</b>
            </div>
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label class="usa=label" for="message-text">Enter New Message</label>
                <textarea id="message-text" formControlName="newMessage" class="usa-textarea maxw-full"></textarea>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
                <button type="button" [disabled]="redirectedFromBol" class="usa-button" (click)="saveMessage()">Save</button>
                <button type="button" class="usa-button usa-button--outline margin-left-2" (click)="cancelMessage()">Cancel</button>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <table class="usa-table usa-table--striped maxw-full">
                  <thead>
                    <tr>
                      <th data-sortable scope="col" role="columnheader">Message History</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (msgHist of messageHistoryArray; track msgHist) {
                      <tr>
                        <th>{{msgHist}}</th>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>
    <button class="usa-button usa-modal__close" aria-label="Close this window" (click)="cancelMessage()">
      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
        <use xlink:href="/assets/uswds/img/sprite.svg#close"></use>
      </svg>
    </button>
  </div>
</div>